"use client";
import { DbProvider } from "@tanstack/react-db";
import { QueryClientProvider } from "@tanstack/react-query";
import type { PropsWithChildren } from "react";
import {
  QueryRequestContext,
  QueryViewerContext,
} from "./browser-data-context";
import type { useBrowserDataOwner } from "./use-browser-data-owner";

export function BrowserDataScopeProvider({
  children,
  scope,
}: PropsWithChildren<{
  readonly scope: ReturnType<typeof useBrowserDataOwner>;
}>) {
  return (
    <QueryViewerContext value={scope.viewerId}>
      <QueryRequestContext
        key={scope.key}
        value={{
          elevatedPrivileges: scope.elevatedPrivileges,
          reportAuthorizationError: scope.reportAuthorizationError,
        }}
      >
        <QueryClientProvider client={scope.queryClient}>
          <DbProvider client={scope.dbClient}>{children}</DbProvider>
        </QueryClientProvider>
      </QueryRequestContext>
    </QueryViewerContext>
  );
}
